import React from "react"
import PropTypes from "prop-types"

import { CTAButton, CustomCTATeaser } from "./style"

const CustomCTA = ({ attribs }) => {
  const fluid = {
    sourceUrl: attribs.sourceurl,
    srcSet: attribs.srcset,
    sizes: "100vw",
    aspectRatio: 1,
  }

  return (
    <CustomCTATeaser
      img={fluid}
      title={attribs.heading}
      excerpt={attribs.message}
      reverse={attribs.imageposition}
      show={attribs.buttontext}
    >
      <CTAButton to={attribs.link} show={attribs.buttontext}>
        {attribs.buttontext}
      </CTAButton>
    </CustomCTATeaser>
  )
}

export default CustomCTA

CustomCTA.defaultProps = {
  title: "Step-by-step business migration guide",
  excerpt:
    "Follow our guide to get started on your business migration journey.",
  label: "Find out more",
  link: "/",
}

CustomCTA.propTypes = {
  title: PropTypes.string,
  excerpt: PropTypes.string,
  imgURL: PropTypes.string,
  label: PropTypes.string,
  link: PropTypes.string,
}
